import {
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  LOADING_TOGGLE_ACTION,
  NAVTOGGLE,
  RESET_MENU,
} from "../actions/AuthActions";

const initialState = {
  authKey: null,
  userDetails: null,
  error: null,
  showLoading: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_CONFIRMED_ACTION:
      return {
        ...state,
        authKey: action.payload.token,
        userDetails: action.payload,
        error: null,
      };

    case LOGIN_FAILED_ACTION:
      return {
        ...state,
        authKey: null,
        userDetails: null,
        error: action.payload,
      };

    case LOGOUT_ACTION:
      return initialState;

    case LOADING_TOGGLE_ACTION:
      return {
        ...state,
        showLoading: action.payload,
      };

    default:
      return state;
  }
}

// function toggleMenu(state = false, action) {
//   console.log("toggleMenu - action type:", action.type);
//   console.log("toggleMenu - current state:", state);
//   console.log("toggleMenu - action payload:", action.payload);

//   switch (action.type) {
//     case NAVTOGGLE: {
//       const newState = !state;
//       console.log("toggleMenu - new state:", newState);
//       return newState;
//     }
//     case RESET_MENU: {
//       console.log("toggleMenu - resetting to false");
//       return false;
//     }
//     default:
//       return state;
//   }
// }

// export { toggleMenu }; changed for first laod for patients
function toggleMenu(state = true, action) {
  console.log("toggleMenu - action type:", action.type);
  console.log("toggleMenu - current state:", state);
  console.log("toggleMenu - action payload:", action.payload);

  switch (action.type) {
    case NAVTOGGLE: {
      const newState = !state;
      console.log("toggleMenu - new state:", newState);
      return newState;
    }

    case RESET_MENU: {
      console.log("toggleMenu - resetting to true (collapsed)");
      return true; // collapse at first load
    }

    default:
      return state;
  }
}

export { toggleMenu };